import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: '6px 16px',
    margin: '10px',
    overflow: 'hidden',
  },
  secondaryTail: {
    backgroundColor: theme.palette.secondary.main,
  },
  dots: {
    backgroundColor: '#FAA500',
  },
  containers: {
    display: 'flex',
    justifyContent: 'space-between',
    margin: '3px 0px',
  },
  mainTitle: {
    textShadow: '1px 1px 2px #000000',
    fontFamily: 'Nunito, sans-serif',
    fontSize: '18px',
    fontWeight: 'Bold',
    margin: '10px 0px',
  },
  subTitle: {
    fontFamily: 'Nunito, sans-serif',
    fontSize: '16px',
    fontWeight: 'Bold',
    color: 'gray',
  },
  titles: {
    fontFamily: 'Nunito, sans-serif',
    fontSize: '16px',
    fontWeight: 'Bold',
    color: '#FAA500',
  },
  description: {
    fontFamily: 'Nunito, sans-serif',
    fontSize: '14px',
    fontWeight: 'Bold',
  },
  dates: {
    fontSize: '18px',
    fontWeight: 'Bold',
  },
  titleContainer: {
    display: 'flex',
    justifyContent: 'space-between',
  },
}));

export default useStyles;
